<div
  class="spinner-border my-5 mx-auto d-block"
  role="status"
  *ngIf="isLoading$ | async"
  attr.aria-label="{{ 'general.loading' | translate }}"
>
</div>

<ng-container *ngIf="!(isLoading$ | async)">
  <div cdkDropList *ngIf="isAllCollapsed(isCollapsed)">
    <div>
      <div
        *ngFor="let tile of tiles; let i = index"
        cdkDrag
        (cdkDragDropped)="!isCollapsed[i] ? drop($event, tile) : null"
        class="card mb-3"
      >
        <div
          class="card-header cursor-move"
          [ngClass]="{
            'rounded-lg border-bottom-0': !isCollapsed[i]
          }"
        >
          <div class="d-flex align-items-center">
            <button
              class="btn btn-sm me-3"
              (click)="!isCollapsed[i] ? toggle(i) : null"
            >
              <i
                role="img"
                class="fa fa-arrows-alt-v"
                attr.aria-label="{{ 'wcag.moveUpOrDown ' | translate }}"
              ></i>
            </button>

            <h4 class="card-title flex-grow-1 user-select-none">
              <div
                [innerHTML]="
                  getTiles(form)[i].value[
                    'description_' + (languageSelected$ | async)
                  ]
                "
              ></div>
            </h4>
          </div>

          <div>
            <button
              class="btn btn-ghost-secondary"
              (click)="onRemoveClick($event, i)"
            >
              <i role="img" class="fa fa-trash-alt"></i>
            </button>
            <button
              class="btn btn-ghost-primary"
              (click)="onClickEdit($event, i)"
            >
              <i
                role="img"
                class="fa fa-pen"
                attr.aria-label="{{ 'general.edit' | translate }}"
              ></i>
            </button>
          </div>
        </div>

        <div *ngIf="isCollapsed[i]">
          <shop-tiles-form
            [form]="getTiles(form)[i]"
            [rolePermissions$]="rolePermissions$"
          ></shop-tiles-form>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isAllCollapsed(isCollapsed)">
    <div>
      <div *ngFor="let tile of tiles; let i = index" class="card mb-3">
        <div
          class="card-header cursor-move"
          [ngClass]="{
            'rounded-lg border-bottom-0': !isCollapsed[i]
          }"
        >
          <div class="d-flex align-items-center">
            <button
              class="btn btn-sm me-3"
              (click)="!isCollapsed[i] ? toggle(i) : null"
            >
              <i
                role="img"
                class="fa fa-arrows-alt-v"
                attr.aria-label="{{ 'general.moveUpOrDown' | translate }}"
              ></i>
            </button>

            <h4 class="card-title flex-grow-1 user-select-none">
              <div
                [innerHTML]="
                  getTiles(form)[i].value[
                    'description_' + (languageSelected$ | async)
                  ]
                "
              ></div>
            </h4>
          </div>

          <div>
            <button
              class="btn btn-ghost-secondary"
              (click)="onRemoveClick($event, i)"
            >
              <i
                role="img"
                class="fa fa-trash-alt"
                attr.aria-label="{{ 'general.delete' | translate }}"
              ></i>
            </button>
            <button
              class="btn btn-ghost-primary"
              (click)="isCollapsed[i] = !isCollapsed[i]"
            >
              <i
                role="img"
                class="fa fa-pen"
                attr.aria-label="{{ 'general.edit' | translate }}"
              ></i>
            </button>
          </div>
        </div>

        <div *ngIf="isCollapsed[i]">
          <shop-tiles-form
            [form]="getTiles(form)[i]"
            [rolePermissions$]="rolePermissions$"
          ></shop-tiles-form>
        </div>
      </div>
    </div>
  </div>
  <div class="form-footer">
    <button
      class="btn btn-primary"
      (click)="onSubmit()"
      [disabled]="disableSaveButton"
    >
      {{ 'general.save' | translate }}
    </button>
  </div>
</ng-container>
